/**
 * Mortgage PRE + Tagular Tracking + Datadog Custom Metrics
 */

const preElement = document.getElementById('pre-display')
const afterPreElement = document.getElementById('after-pre-display')

import datadog from 'js/services/datadog-metrics'
const ctaButtons = document.querySelectorAll(
  '#pre-display button.Button--primary, #skip-and-show-rates, #rates-chart-tooltip-link'
)
if (preElement) {
  for (const ctaButton of ctaButtons) {
    ctaButton.addEventListener('click', function() {
      var txt = this.textContent || this.innerText
      datadog.increment({
        name: 'buttons.cta',
        value: 1,
        tags: ['button:' + txt, 'preActive:' + (window.preActive ?? false)]
      })
    })
  }
}

window.onload = function() {
  datadog.increment({
    name: 'session.start',
    value: 1,
    tags: ['preActive:' + (window.preActive ?? false)]
  })
}

import tagularModule from 'js/store/helpers/tagular'
;(function() {
  if (typeof tagular !== 'function') {
    return
  }

  var correlationId = tagularModule.generateUniqueId()

  var eventList = [
    {
      selector: '[data-tracking-id="v1-mortgage-type-select"]', // pre-v1 loan type dropdown
      type: 'change',
      handler: loanTypeInputted
    },
    {
      selector: '[data-tracking-id="v3-mortgage-type-select"]', // pre-v2 loan type dropdown
      type: 'change',
      handler: function(event) {
        loanTypeInputted(event, {
          formName: 'PRE',
          formType: 'PRE'
        })
      }
    },
    {
      selector: '#pre-zipcode [data-tracking-id="zip-code"]', // zip code input - desktop
      type: 'keydown',
      handler: zipcodeInputted
    },
    {
      selector: '#pre-zipcode-mobile [data-tracking-id="zip-code"]', // zip code input - mobile
      type: 'keydown',
      handler: zipcodeInputted
    },

    {
      selector: '#pre-zipcode form', // zip code next button - desktop
      type: 'submit',
      handler: function(event) {
        event.preventDefault()
        universalClick(event.target, {
          text: 'next',
          name: 'Zipcode',
          position: 'top',
          elementType: 'button'
        })
        window.initialDimensions.zipCode = document.querySelector(
          '#pre-zipcode [data-tracking-id="zip-code"]'
        ).value
        loadMRTCode()
      }
    },
    {
      selector: '#pre-zipcode-mobile form', // zip code next button - mobile
      type: 'submit',
      handler: function(event) {
        event.preventDefault()
        universalClick(event.target, {
          text: 'next',
          name: 'Zipcode',
          position: 'bottom',
          elementType: 'button'
        })
        window.initialDimensions.zipCode = document.querySelector(
          '#pre-zipcode-mobile [data-tracking-id="zip-code"]'
        ).value
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v1-skip-and-show-rates"]', // skip and show me the rates
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Skip',
          position: 'top',
          elementType: 'link'
        })
        window.initialDimensions.zipCode = window.geoZipCode
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-apr-1"]', // spotlight rate card - left
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'Bankrate Lowest Rate Left',
          elementType: 'card'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-rate-card-apr-1"]', // pre-v2 spotlight rate card - left
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'Bankrate Lowest Rate Left',
          elementType: 'card',
          location: 'PRE'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-rate-card-apr-1"]', // pre-v2 lowest offers
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'button',
          name: 'Lowest Offers',
          position: 'middle',
          text: "Bankrate's lowest offers",
          location: 'PRE'
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-apr-2', // spotlight rate card - right
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'Bankrate Lowest Rate Right',
          elementType: 'card'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-rate-card-apr-2', // pre-v2 spotlight rate card - right
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'Bankrate Lowest Rate Right',
          elementType: 'card',
          location: 'PRE'
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-cta-1"]', // spotlight rate card CTA - left
      type: 'click',
      handler: function(event) {
        event.preventDefault()
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'See all rates left'
        })
        rateCardClickHandler('rate-card-title-1')
      }
    },
    {
      selector: '[data-tracking-id="v3-rate-card-cta-1"]', // pre-v2 spotlight rate card CTA - left
      type: 'click',
      handler: function(event) {
        event.preventDefault()
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'See all rates left',
          location: 'PRE'
        })
        rateCardClickHandler('rate-card-title-1')
      }
    },
    {
      selector: '[data-tracking-id="rate-chart-cta"]',
      type: 'click',
      handler: function(event) {
        event.preventDefault()
        let ratetype = event.target.dataset.ratetype
        let rateterm = event.target.dataset.rateterm
        if (event.target.id === 'btn-all-refinance-mortgages') {
          universalClick(event.target, {
            elementType: 'button',
            htmlId: '',
            location: 'PRE',
            name: 'Rate Trends',
            position: 'middle',
            text: `See all ${ratetype} rates`
          })
        }
        rateChartClickHandler(ratetype, rateterm)
      }
    },
    {
      selector: '#rateTrendsChart',
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'Rate Trends',
          htmlId: '',
          location: 'PRE',
          name: 'Rate Trends Graph',
          position: 'middle',
          text: 'Bankrate Rate Trends'
        })
      }
    },
    {
      selector: '[data-tracking-id="rate-chart-terms"]',
      type: 'click',
      handler: function(event) {
        let text
        switch (event.target.dataset.rateterms) {
          case '30yr-fixed':
            text = '30 yr fixed'
            break
          case '15yr-fixed':
            text = '15 yr fixed'
            break
          case '10yr-fixed':
            text = '10 yr fixed'
            break
          case '51-arm':
            text = '5/1 ARM'
            break
          default:
            return null
        }
        universalClick(event.target, {
          elementType: 'button',
          htmlId: '',
          name: 'Rate Trends',
          position: 'middle',
          text: text,
          location: 'PRE'
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-cta-2"]', // spotlight rate card CTA - right
      type: 'click',
      handler: function(event) {
        event.preventDefault()
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'See all rates right'
        })
        rateCardClickHandler('rate-card-title-2')
      }
    },
    {
      selector: '[data-tracking-id="v3-rate-card-cta-2"]', // pre-v2 spotlight rate card CTA - right
      type: 'click',
      handler: function(event) {
        event.preventDefault()
        universalClick(event.target, {
          name: 'Rate Card',
          position: 'middle',
          text: 'See all rates right',
          location: 'PRE'
        })
        rateCardClickHandler('rate-card-title-2')
      }
    },
    {
      selector: '[data-tracking-id="v1-wp-content-cta"]', // cta below WP content
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Get matched with a lender',
          position: 'bottom'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-wp-content-cta"]', // cta below WP content
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Get matched with a lender',
          position: 'bottom',
          location: 'PRE'
        })
      }
    },
    {
      selector: '#pre-loantype [data-tracking-id="pre-cta-browsing"]', // select loan type cta - Browsing - desktop
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top'
        })
        window.initialDimensions.zipCode = window.geoZipCode
        loadMRTCode()
      }
    },
    {
      selector: '#pre-loantype-mobile [data-tracking-id="pre-cta-browsing"]', // select loan type cta - Browsing - mobile
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'bottom'
        })
        window.initialDimensions.zipCode = window.geoZipCode
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v1-pre-cta-purchase"]', // select loan type cta - purchase - desktop
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top'
        })
        selectLoanType('Purchase')
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-cta-purchase"]', // select loan type cta - purchase - desktop
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top',
          location: 'PRE',
          text: 'CTA 2'
        })
        selectLoanType('Purchase')
      }
    },
    {
      selector: '[data-tracking-id="v1-sticky-pre-cta-purchase"]', // select loan type cta - purchase - mobile
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'sticky banner',
          name: 'Loan Type',
          position: 'bottom'
        })
        selectLoanType('Purchase')
      }
    },
    {
      selector: '[data-tracking-id="v3-sticky-pre-cta-purchase"]', // select loan type cta - purchase - mobile
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'sticky banner',
          name: 'Loan Type',
          position: 'bottom',
          location: 'PRE',
          text: 'CTA 3'
        })
        selectLoanType('Purchase')
      }
    },
    {
      selector: '[data-tracking-id="v1-pre-cta-refinance"]', // select loan type cta - Refinance - desktop
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top'
        })
        selectLoanType('Refinance')
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-cta-refinance"]', // select loan type cta - Refinance - desktop
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top',
          location: 'PRE',
          text: 'CTA 3'
        })
        selectLoanType('Refinance')
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-cta-browsing"]', // skip and show me the rates
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top',
          location: 'PRE',
          text: 'CTA 1'
        })

        window.initialDimensions.zipCode = window.geoZipCode
        if (window.ImJustBrowsingXP) {
          ImJustBrowsingXPHandle()
          universalView(
            document.querySelector('[v3-pre-just-browsing-step2]'),
            {
              elementType: 'PRE Step 2',
              name: "I'm Just Browsing Step 2",
              position: 'top',
              text: 'What are you browsing for?',
              location: 'PRE Step 2'
            }
          )
        } else {
          loadMRTCode()
        }
      }
    },
    {
      selector: '[data-tracking-id="v3-sticky-pre-cta-browsing"]', // skip and show me the rates
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'sticky banner',
          name: 'Loan Type',
          position: 'bottom',
          location: 'PRE',
          text: 'CTA 1'
        })
        window.initialDimensions.zipCode = window.geoZipCode
        if (window.ImJustBrowsingXP) {
          ImJustBrowsingXPHandle()
          universalView(
            document.querySelector('[v3-pre-just-browsing-fixed-step2]'),
            {
              elementType: 'PRE Step 2',
              name: "I'm Just Browsing Step 2",
              position: 'bottom',
              text: 'What are you browsing for?',
              location: 'Sticky Banner'
            }
          )
        } else {
          loadMRTCode()
        }
      }
    },
    {
      selector: '[data-tracking-id="v1-sticky-pre-cta-refinance"]', // select loan type cta - Refinance - mobile
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'sticky banner',
          name: 'Loan Type',
          position: 'bottom'
        })
        selectLoanType('Refinance')
      }
    },
    {
      selector: '[data-tracking-id="v3-sticky-pre-cta-refinance"]', // select loan type cta - Refinance - mobile
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'sticky banner',
          name: 'Loan Type',
          position: 'bottom',
          location: 'PRE',
          text: 'CTA 2'
        })
        selectLoanType('Refinance')
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-cta-purchase-step-one"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top',
          location: 'PRE',
          text: 'CTA 1'
        })
        selectLoanType('Purchase')
      }
    },
    {
      selector: '[data-tracking-id="v3-sticky-pre-cta-purchase-step-one"]', // select loan type cta - purchase - mobile
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'sticky banner',
          name: 'Loan Type',
          position: 'bottom',
          location: 'PRE',
          text: 'CTA 1'
        })
        selectLoanType('Purchase')
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-cta-browsing-all-rates-step-one"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          name: 'Loan Type',
          position: 'top',
          location: 'PRE',
          text: 'CTA 3'
        })

        window.initialDimensions.zipCode = window.geoZipCode
        window.initialDimensions.mortgageType = 'Purchase'
        loadMRTCode()
      }
    },
    {
      selector:
        '[data-tracking-id="v3-sticky-v3-cta-browsing-all-rates-step-one"]', // skip and show me the rates
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'sticky banner',
          name: 'Loan Type',
          position: 'bottom',
          location: 'PRE',
          text: 'CTA 3'
        })
        window.initialDimensions.zipCode = window.geoZipCode
        window.initialDimensions.mortgageType = 'Purchase'
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v1-pre-qn-loantype"]', // select loantype question
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'PRE',
          name: 'PurchaseRefi',
          position: 'top',
          text: 'What type of home loan are you looking for?'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-qn-loantype"]', // select loantype question
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'PRE',
          name: 'PurchaseRefi',
          position: 'top',
          location: 'PRE',
          text: 'What type of home loan are you looking for?'
        })
      }
    },
    {
      selector: '#pre-zipcode', // input zipcode question
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'PRE',
          name: 'Zipcode',
          position: 'top',
          text: 'Enter your ZIP code for personalized rates'
        })
      }
    },
    {
      selector: '#pre-zipcode-mobile', // input zipcode question
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'PRE',
          name: 'Zipcode',
          position: 'bottom',
          text: 'Enter your ZIP code for personalized rates'
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-rate-card-apr-1"]', // rate cards
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'button',
          name: 'Lowest Offers',
          position: 'middle',
          text: "Bankrate's lowest offers"
        })
      }
    },
    {
      selector: '[data-tracking-id="v1-wp-content-cta"]', // cta below WP content
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'button',
          name: 'Get matched with a lender',
          position: 'bottom'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-wp-content-cta"]', // cta below WP content
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'button',
          name: 'Get matched with a lender',
          position: 'bottom',
          location: 'PRE'
        })
      }
    },
    {
      selector: '#after-pre-back',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: 'Back',
          text: 'Back',
          position: 'top',
          location: 'rate table'
        })
        clickBacktoPre()
      }
    },
    {
      selector: '#split-after-pre-back',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: 'Back',
          text: 'Back',
          position: 'top',
          location: 'rate table'
        })
        window.location.replace('/mortgages/30-year-mortgage-rates/')
      }
    },
    {
      selector: '[data-tracking-id="v1-pre-loantype-mobile"]', // sticky banner
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'sticky banner',
          name: 'PurchaseRefi',
          position: 'bottom',
          text: 'What type of home loan are you looking for?'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-loantype-mobile"]', // sticky banner
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'sticky banner',
          name: 'PurchaseRefi',
          position: 'bottom',
          text: 'What type of home loan are you looking for?',
          location: 'PRE'
        })
      }
    },
    {
      selector: '#on-this-page-bar', // When the on this page drawer is above the fold
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'drawer',
          location: 'PRE',
          name: 'On this page',
          position: 'middle',
          text: 'On this page'
        })
      }
    },
    {
      selector: '#on-this-page-bar', // When a user clicks on this page drawer
      type: 'click',
      handler: function(event) {
        // there is a race condition between Classy setting aria-expanded attribute and this event
        // added a deplay to fire this event 100ms later
        window.setTimeout(function() {
          const actionOutcome =
            document
              .getElementById('on-this-page-bar')
              .getAttribute('aria-expanded') === 'false'
              ? 'close'
              : 'open'
          universalClick(event.target, {
            elementType: 'drawer',
            location: 'PRE',
            name: 'On this page',
            position: 'middle',
            text: 'On this page ' + actionOutcome,
            actionOutcome: actionOutcome
          })
        }, 100)
      }
    },
    {
      selector: '#ratetable-on-this-page-bar', // When a user clicks on this page drawer
      type: 'click',
      handler: function(event) {
        // there is a race condition between Classy setting aria-expanded attribute and this event
        // added a deplay to fire this event 100ms later
        window.setTimeout(function() {
          const actionOutcome =
            document
              .getElementById('ratetable-on-this-page-bar')
              .getAttribute('aria-expanded') === 'false'
              ? 'close'
              : 'open'
          universalClick(event.target, {
            elementType: 'drawer',
            location: 'rate table',
            name: 'On this page',
            position: 'top',
            text: 'On this page',
            actionOutcome: actionOutcome
          })
        }, 100)
      }
    },
    {
      selector: '.table-of-contents-mobile', // When the onthispage sticky banner pops up
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'sticky banner',
          location: 'PRE',
          name: 'On this page',
          position: 'top',
          text: 'On this page'
        })
      }
    },
    {
      selector: '.mortgage__sidebar .table-of-contents-desktop', // on this page - sidebar nav
      type: 'view',
      handler: function(target) {
        universalView(target, {
          elementType: 'sidebar',
          location: 'PRE',
          name: 'On this page',
          position: 'middle',
          text: 'On this page'
        })
      }
    },
    {
      selector: '#on-this-page-list a', // When a user clicks 'On this page' links - drawer
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: event.target.getAttribute('data-beam-type') || 'link',
          location: event.target.getAttribute('data-beam-location') || 'PRE',
          name: event.target.getAttribute('data-beam-name') || 'On this page',
          position: 'top',
          text: event.target.getAttribute('data-beam-text')
        })
        event.preventDefault()
        scrollTo(event.target.getAttribute('href').replace('#', ''))
        var navController = document.querySelector(
          '[data-table-of-contents-controller]'
        )
        navController.firstElementChild.classList.add('--is-sticky-bottom')
      }
    },
    {
      selector: '#on-this-page-list-pre a', // When a user clicks 'On this page' links - drawer
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: event.target.getAttribute('data-beam-type') || 'link',
          location: event.target.getAttribute('data-beam-location') || 'PRE',
          name: event.target.getAttribute('data-beam-name') || 'On this page',
          position: 'top',
          text: event.target.getAttribute('data-beam-text')
        })
        event.preventDefault()
        scrollTo(event.target.getAttribute('href').replace('#', ''))
        var navController = document.querySelector(
          '[data-table-of-contents-controller-pre]'
        )
        navController.firstElementChild.classList.add('--is-sticky')
      }
    },
    {
      selector: '.mortgage__sidebar li a', // When a user clicks 'On this page' links - sidebar
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: event.target.getAttribute('data-beam-type') || 'link',
          location: event.target.getAttribute('data-beam-location') || 'PRE',
          name: event.target.getAttribute('data-beam-name') || 'On this page',
          position: 'middle',
          text: event.target.getAttribute('data-beam-text')
        })
        event.preventDefault()
        scrollTo(event.target.getAttribute('href').replace('#', ''))
      }
    },
    {
      selector: '.table-of-contents-mobile__links li a', // When a user clicks 'On this page' links - sticky banner
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: event.target.getAttribute('data-beam-type') || 'link',
          location: event.target.getAttribute('data-beam-location') || 'PRE',
          name: event.target.getAttribute('data-beam-name') || 'On this page',
          position: 'popup',
          text: event.target.getAttribute('data-beam-text')
        })
        event.preventDefault()
        scrollTo(event.target.getAttribute('href').replace('#', ''))
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-cta1"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'PRE Step 2',
          text: 'CTA 1'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-cta2"]', // skip and show me the rates
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'PRE Step 2',
          text: 'CTA 2'
        })
        window.initialDimensions.zipCode = window.geoZipCode
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-cta3"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'PRE Step 2',
          text: 'CTA 3'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-cta4"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'PRE Step 2',
          text: 'CTA 4'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-cta5"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'PRE Step 2',
          text: 'CTA 5'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-fixed-cta1"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'Sticky Banner',
          text: 'CTA 1'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-fixed-cta2"]', // skip and show me the rates
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'Sticky Banner',
          text: 'CTA 2'
        })
        window.initialDimensions.zipCode = window.geoZipCode
        loadMRTCode()
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-fixed-cta3"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'Sticky Banner',
          text: 'CTA 3'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-fixed-cta4"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'Sticky Banner',
          text: 'CTA 4'
        })
      }
    },
    {
      selector: '[data-tracking-id="v3-pre-just-browsing-fixed-cta5"]',
      type: 'click',
      handler: function(event) {
        universalClick(event.target, {
          elementType: 'button',
          name: "I'm just browsing",
          position: 'top',
          location: 'Sticky Banner',
          text: 'CTA 5'
        })
      }
    }
  ]

  window.preActive = true
  window.cohesion('preamp:decisionsReceived', function(decision) {
    // If the Remove PRE preamp asset is active remove the PRE
    if (
      decision.placements.find(
        placement => placement.assetName === 'BR-Mortgage-Remove-PRE'
      )
    ) {
      document.querySelectorAll('.pre').forEach(function(el) {
        addClass(el, 'display-none')
      })
      document.querySelectorAll('.non-pre').forEach(function(el) {
        removeClass(el, 'display-none')
      })
      loadMRTCode()
      var checkApp = setInterval(function() {
        if (typeof window.setFlag != 'undefined') {
          window.setFlag('hideBrSelectText', false)
          clearInterval(checkApp)
        }
      }, 100)
      window.preActive = false
    }
  })

  /* Attach event listeners */
  eventList.forEach(function(event) {
    var elements = document.querySelectorAll(event.selector)
    elements.forEach(element => {
      switch (event.type) {
        case 'view': {
          event.listener = function() {
            // do not send PRE view tracking events if PRE is hidden by preamp asset
            if (elementInView(element) && window.preActive) {
              event.handler(element)
              // console.log(event.selector + ' is in viewport')
              // event should only fire once
              window.removeEventListener('scroll', event.listener)
            }
          }
          window.addEventListener('scroll', event.listener)
          event.listener()
          break
        }
        case 'keydown': {
          element.addEventListener('keydown', function(keyDownEvent) {
            if (event.timer) {
              window.clearTimeout(event.timer)
            }
            event.timer = window.setTimeout(function() {
              event.handler(keyDownEvent)
              delete event.timer
            }, 2000)
          })
          break
        }
        default: {
          element.addEventListener(event.type, event.handler)
          break
        }
      }
    })
  })

  /* Helper functions */

  function getElementType(eventTarget) {
    var nodeName = eventTarget.nodeName.toLowerCase()
    if (nodeName === 'a') {
      return eventTarget.className.indexOf('button') === -1 ? 'link' : 'button'
    }
    return nodeName
  }

  function elementInView(el) {
    var bounding = el.getBoundingClientRect()
    var display = getComputedStyle(el).getPropertyValue('display')
    return (
      display !== 'none' &&
      bounding.top >= 0 &&
      bounding.bottom <= window.innerHeight
    )
  }

  function addClass(el, classNameToAdd) {
    el.className += ' ' + classNameToAdd
  }

  function removeClass(el, classNameToRemove) {
    var elClass = ' ' + el.className + ' '
    while (elClass.indexOf(' ' + classNameToRemove + ' ') !== -1) {
      elClass = elClass.replace(' ' + classNameToRemove + ' ', '')
    }
    el.className = elClass
  }

  function scrollTo(htmlId) {
    const targetEl = document.getElementById(htmlId)
    // avoid overlay by sticky banner
    let offset = window.innerWidth > 999 ? 30 : 80
    if (targetEl.classList.contains('accordion__content')) {
      offset += 50
      const accordionToggle = document.querySelector(
        '[aria-controls="' + htmlId + '"][aria-expanded="false"]'
      )
      if (accordionToggle) {
        accordionToggle.click()
      }
    }
    // scroll
    targetEl.scrollIntoView(true)
    window.scroll(0, window.scrollY - offset)
    // update url
    history.replaceState(null, '', '#' + htmlId)
  }

  window.hasLoaded = false
  function loadMRTCode() {
    if (window.splitPre) {
      // Clears query params for when we navigate back and forth between
      // pre and the ratetable we dont load the ratetable with stale options.
      history.replaceState(null, null, '?')
      let queryParams = new URLSearchParams(window.location.search)
      queryParams.set('zipCode', window.initialDimensions.zipCode || '')
      queryParams.set(
        'mortgageType',
        window.initialDimensions.mortgageType || ''
      )
      if (window.initialDimensions.mortgageType === 'Refinance') {
        queryParams.set(
          'refinanceLoanTerms',
          window.initialDimensions.refinance.loanTerms.join(',') || ''
        )
      } else {
        queryParams.set(
          'purchaseLoanTerms',
          window.initialDimensions.purchase.loanTerms.join(',') || ''
        )
      }

      window.location.assign(
        `/mortgages/${
          window.originalSlug
        }-personalized/?${queryParams.toString()}`
      )
      return
    }
    addClass(preElement, 'display-none')
    removeClass(afterPreElement, 'display-none')
    displaySidebarRateTrendsSection()
    if (!window.hasLoaded) {
      window.scrollTo(0, 0)
      var urls = window.mrtUrls.split(',')
      var rateTableApp = document.getElementById('mortgage-rate-table-app')

      Promise.all(
        urls.map(function(url) {
          return window.loadScript(url, rateTableApp)
        })
      )
      window.hasLoaded = true
    }
    loadBackButtonPopState()
  }

  function displaySidebarRateTrendsSection() {
    let sidebarRatesTrendsMenuItem = document.getElementById(
      'sidebarRatesTrendsMenuItem'
    )
    let sidebarRatesTrendsSection = document.getElementById(
      'sidebarRatesTrendsSection'
    )
    if (sidebarRatesTrendsMenuItem !== null) {
      removeClass(sidebarRatesTrendsMenuItem, 'display-none')
    }
    if (sidebarRatesTrendsSection !== null) {
      removeClass(sidebarRatesTrendsSection, 'display-none')
    }
  }

  function hideSidebarRateTrendsSection() {
    let sidebarRatesTrendsMenuItem = document.getElementById(
      'sidebarRatesTrendsMenuItem'
    )
    let sidebarRatesTrendsSection = document.getElementById(
      'sidebarRatesTrendsSection'
    )
    if (sidebarRatesTrendsMenuItem !== null) {
      addClass(sidebarRatesTrendsMenuItem, 'display-none')
    }
    if (sidebarRatesTrendsSection !== null) {
      addClass(sidebarRatesTrendsSection, 'display-none')
    }
  }

  function rateChartClickHandler(rateType, rateTerm) {
    // If PRE is not enabled
    if (!preElement) {
      scroll(0, 0)
    } else {
      let type = rateType === 'refinance' ? 'Refinance' : 'Purchase'
      let termParam =
        rateType === 'refinance' ? 'refinanceLoanTerms' : 'purchaseLoanTerms'
      let termAuxArray = rateTerm.split('-')
      let termValue = termAuxArray[0] + termAuxArray[1]
      let queryParams = new URLSearchParams(window.location.search)
      queryParams.set('mortgageType', type)
      queryParams.set(termParam, termValue)
      history.replaceState(null, null, '?' + queryParams.toString())
      window.preActive = false
      loadMRTCode()
    }
  }

  function rateCardClickHandler(elementId) {
    var rateCard = document.getElementById(elementId).textContent.split(' ')
    var term = rateCard[0].replace('-year', 'yr')
    if (term.includes('/')) term = term.replace('/', '-') + 'arm'

    if (rateCard[2] === 'Refinance') {
      window.initialDimensions.mortgageType = 'Refinance'
      window.initialDimensions.refinance.loanTerms = [term]
    } else {
      window.initialDimensions.mortgageType = 'Purchase'
      window.initialDimensions.purchase.loanTerms = [term]
    }
    let queryParams = new URLSearchParams(window.location.search)
    queryParams.set('mortgageType', window.initialDimensions.mortgageType)
    history.replaceState(null, null, '?' + queryParams.toString())
    window.preActive = false
    loadMRTCode()
  }

  function selectLoanType(type) {
    window.initialDimensions.mortgageType = type
    let queryParams = new URLSearchParams(window.location.search)
    queryParams.set('mortgageType', type)
    history.replaceState(null, null, '?' + queryParams.toString())
    window.preActive = false
    loadMRTCode()
  }

  /* All handlers */

  function zipcodeInputted(event) {
    window.tagular('beam', 'FieldInputted', {
      '@type': 'redventures.usertracking.v3.FieldInputted',
      correlationId: correlationId,
      formContext: {
        formId: correlationId,
        formName: 'PRE',
        formType: 'PRE'
      },
      userInputField: {
        fieldLabel: 'zip code',
        fieldName: 'zip code',
        fieldType: 'zip code',
        fieldValue: event.target.value
      }
    })
  }

  function loanTypeInputted(event, params = {}) {
    window.tagular('beam', 'FieldInputted', {
      '@type': 'redventures.usertracking.v3.FieldInputted',
      correlationId: correlationId,
      formContext: {
        formId: correlationId,
        formName: params.formName || 'PRE',
        formType: params.formType || 'PRE'
      },
      userInputField: {
        fieldLabel: 'loan type',
        fieldName: 'loan type',
        fieldType: 'loan type',
        fieldValue: event.target.value
      }
    })
  }

  function universalClick(target, params) {
    const payload = {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      webElement: {
        elementType: params.elementType || getElementType(target),
        htmlId: typeof params.htmlId === undefined ? target.id : params.htmlId,
        location: params.location || 'PRE',
        name: params.name,
        position: params.position,
        text: params.text || target.innerText
      }
    }
    if (params.actionOutcome) {
      payload.actionOutcome = params.actionOutcome
    }
    window.tagular('beam', 'ElementClicked', payload)
  }

  function universalView(target, params) {
    window.tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      webElement: {
        elementType: params.elementType,
        htmlId: typeof params.htmlId === undefined ? target.id : params.htmlId,
        location: params.location || 'PRE',
        name: params.name,
        position: params.position,
        text: params.text || target.innerText
      }
    })
  }

  function clickBacktoPre() {
    window.history.pushState(
      {},
      document.title,
      location.pathname + window.location.search
    )

    //reloading on back is temp fix which is why left in code below it
    window.location.reload()
    window.preActive = true
    window.hasLoaded = false
    removeClass(preElement, 'display-none')
    addClass(afterPreElement, 'display-none')
    hideSidebarRateTrendsSection()
  }

  function loadBackButtonPopState() {
    const backPath = location.pathname + window.location.search

    history.replaceState(
      null,
      document.title,
      location.pathname + '#!/prestatehistory'
    )
    history.pushState(null, document.title, backPath)

    window.addEventListener(
      'popstate',
      function() {
        if (location.hash === '#!/prestatehistory') {
          history.replaceState(null, document.title, backPath)
          setTimeout(function() {
            clickBacktoPre()
          }, 0)
        }
      },
      false
    )
  }

  function ImJustBrowsingXPHandle() {
    var preLoadTitle = document.getElementById('pre-qn-loantype')
    preLoadTitle.classList.add('display-none')
    const ctaGroup = document.querySelector('.cta-group')
    var preLoadTypeSectionMobile = document.getElementById(
      'pre-loantype-fixed-seccion'
    )
    var justBrowsingSection = document.getElementById('just-browsing-section')
    var justBrowsingSectionMobile = document.getElementById(
      'just-browsing-section-fixed'
    )

    while (ctaGroup.firstChild) {
      ctaGroup.removeChild(ctaGroup.firstChild)
    }

    preLoadTypeSectionMobile.classList.add('display-none')
    justBrowsingSection.classList.remove('display-none')
    justBrowsingSectionMobile.classList.remove('display-none')

    justBrowsingSection.classList.add('display-block')
    justBrowsingSection.classList.add('fade-in-ijb')
    justBrowsingSectionMobile.classList.add('display-block')
  }

  /* end of handlers */
})()
